import React, { useEffect, useRef } from 'react';
import { Button, Input, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useState } from "react";
import { getAdminPannel, updateUser } from '../handler/LoginAndSingupHandler';
import UserLoader from '../Dashboard/UserLoader';

const UpdateUserByAdmin = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loader, setLoader] = useState(false);
    // Handle page change
    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const getUserInformation = async () => {
        setLoader(true);
        var response = await getAdminPannel(4);
        if (response.statusCode === 200) {
            debugger
            const userDetails = response.data.adminPannel.userDetails;
            setUserInformation(userDetails);
            setFilterData(userDetails);
        }
        setLoader(false);
    }
    var runValue = useRef(false);
    useEffect(() => {
        if (runValue.current === false) {
            getUserInformation();
            runValue.current = true;
        }
    }, [runValue]);
    const [userInformation, setUserInformation] = useState([
        {
            "userInformationId": 0,
            "growniverseId": "string",
            "fullName": "string",
            "emailId": "string",
            "phoneNumber": "string",
            "status": 1,
            "registrationDate": "2025-01-07T06:23:53.095Z",
            "dateOfBirth": "2025-01-07",
            "packageId": 0,
            "packageName": "",
            "affiliateApproved": false
        }
    ]);

    const [filterData, setFilterData] = useState([
        {
            "userInformationId": 0,
            "growniverseId": "string",
            "fullName": "string",
            "emailId": "string",
            "phoneNumber": "string",
            "status": 1,
            "registrationDate": "2025-01-07T06:23:53.095Z",
            "dateOfBirth": "2025-01-07",
            "packageId": 0,
            "packageName": "",
            "affiliateApproved": false
        }
    ]);
    // Slice data for current page
    const paginatedData = filterData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    const UpdatePackageSection = (statement: any) => {
        debugger
        setPackageSection(true);
        setPackageUserDetail(statement);
        setNewPackageId(statement.packageId)
    }
    const [packageUserDetail, setPackageUserDetail] = useState({
        "userInformationId": 0,
        "growniverseId": "",
        "fullName": "",
        "emailId": "",
        "phoneNumber": "",
        "status": 1,
        "registrationDate": "",
        "dateOfBirth": "",
        "packageId": 0,
        "packageName": "",
        "affiliateApproved": false
    })
    const [packageSection, setPackageSection] = useState(false);
    const packages = [
        { packageId: 0, packageName: "No Package" },
        { packageId: 1, packageName: "Basic Package" },
        { packageId: 2, packageName: "Advanced Package" },
        { packageId: 3, packageName: "Silver Package" },
        { packageId: 4, packageName: "Gold Package" },
        { packageId: 5, packageName: "Platinum Package" },
    ];

    const handleChange = (event: any) => {
        const newId = parseInt(event.target.value);
        setNewPackageId(newId);
        setPackageUserDetail({
            ...packageUserDetail,
            packageId: newId
        });

    };


    const UpdatePackage = async () => {
        setLoader(true);
        setPackageSection(false);
        debugger
        const newPackage = packages.find(data => data.packageId === newPackageId);
        await updateUser({
            "userInformationId": packageUserDetail.userInformationId,
            "newPackageId": newPackage?.packageId ?? 1,
            "newPackageName": newPackage?.packageName ?? "Basic Package",
            "affiliateApproved":packageUserDetail.affiliateApproved
        });
        getUserInformation();
        setLoader(false);
    }
    const [newPackageId, setNewPackageId] = useState(0);
    const search = (event: any) => {
        const searchTerm = event.target.value.toLowerCase();
        const filtered = userInformation.filter((data) =>
            data.fullName.toLowerCase().includes(searchTerm) ||
            data.growniverseId.toLowerCase().includes(searchTerm)
        );
        setFilterData(filtered);
        setPage(0); // Reset to first page
    }
    return (
        <>
            {
                loader && (
                    <UserLoader />
                )
            }
            {
                !loader && (
                    <section className='headerBackground'>
                        <div className='space-ptb achievers-section headerBackground' style={{ borderStyle: "inset", borderColor: "white", padding: "30px" }}>
                            <TableContainer style={{ background: "white" }}>
                                <h3 style={{ textAlign: "center" }}>Growniverse Users</h3>
                                <div style={{ padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Input placeholder='Search' onChange={search} />
                                </div>
                                <Table>
                                    <TableHead>
                                        <TableRow >
                                            <TableCell align="center">UserInformationId</TableCell>
                                            <TableCell align="center">GrowniverseId</TableCell>
                                            <TableCell align="center">FullName</TableCell>
                                            <TableCell align="center">Status</TableCell>
                                            <TableCell align='center'>Package</TableCell>
                                            <TableCell align='center'>Update Package</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {paginatedData.map((statement, index) => (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell align="center">
                                                    {statement.userInformationId}
                                                </TableCell>
                                                <TableCell align="center">{statement.growniverseId}</TableCell>
                                                <TableCell align="center">{statement.fullName}</TableCell>
                                                <TableCell align="center">{statement.status === 0 ? "Email Not Confirmed" : statement.status === 1 ? "Email Confirmed" : statement.status === 2 ? "No Package" : statement.status === 3 ? "In Progress" : statement.status === 4 ? "KYC Pending" : statement.status === 5 ? "KYC Requested" : statement.status === 6 ? "Active" : "InActive"}</TableCell>
                                                <TableCell align="center">{statement.packageName}</TableCell>
                                                <TableCell align="center"><Button style={{ border: "1px solid #343434" }} onClick={() => { UpdatePackageSection(statement) }} disabled={packageSection}>Update Package</Button></TableCell>
                                            </TableRow>
                                        </TableBody>
                                    ))}
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[10, 20]}
                                    component="div"
                                    count={userInformation.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </div>
                    </section>
                )
            }
           {packageSection && (
  <section
    style={{
      background: "rgba(0,0,0,0.6)", // semi-transparent overlay
      height: "100%",
      width: "100%",
      position: "fixed",
      left: 0,
      top: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    }}
  >
    <div
      style={{
        background: "#ffffff",
        width: "90%",
        maxWidth: "600px",
        borderRadius: "12px",
        padding: "30px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "20px",
          fontWeight: "700",
          fontSize: "20px",
          color: "#003b46",
          borderBottom: "2px solid #eee",
          paddingBottom: "10px",
        }}
      >
        Update Package Details
      </h2>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: "600", color: "#333" }}>
              GrowniverseId
            </TableCell>
            <TableCell>:</TableCell>
            <TableCell>{packageUserDetail.growniverseId}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ fontWeight: "600", color: "#333" }}>
              User Name
            </TableCell>
            <TableCell>:</TableCell>
            <TableCell>{packageUserDetail.fullName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ fontWeight: "600", color: "#333" }}>
              Current Package
            </TableCell>
            <TableCell>:</TableCell>
            <TableCell>{packageUserDetail.packageName}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ fontWeight: "600", color: "#333" }}>
              New Package
            </TableCell>
            <TableCell>:</TableCell>
            <TableCell>
              <select
                id="packageDropdown"
                value={newPackageId}
                onChange={handleChange}
                style={{
                  padding: "10px",
                  border: "1px solid #ccc",
                  background: "#f9f9f9",
                  borderRadius: "8px",
                  width: "100%",
                }}
              >
                <option value="" disabled>
                  Select a package
                </option>
                {packages.map((pkg) => (
                  <option key={pkg.packageId} value={pkg.packageId}>
                    {pkg.packageName}
                  </option>
                ))}
              </select>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ fontWeight: "600", color: "#333" }}>
              Affiliate Approved
            </TableCell>
            <TableCell>:</TableCell>
            <TableCell>
              <select
                id="affiliateDropdown"
                value={packageUserDetail.affiliateApproved ? "true" : "false"}
                onChange={(e) =>
                  setPackageUserDetail({
                    ...packageUserDetail,
                    affiliateApproved: e.target.value === "true",
                  })
                }
                style={{
                  padding: "10px",
                  border: "1px solid #ccc",
                  background: "#f9f9f9",
                  borderRadius: "8px",
                  width: "100%",
                }}
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="false">Not Approved</option>
                <option value="true">Approved</option>
              </select>
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "30px",
        }}
      >
        <Button
          variant="outlined"
          style={{
            borderRadius: "8px",
            padding: "8px 20px",
            fontWeight: "600",
          }}
          onClick={() => setPackageSection(false)}
        >
          Close
        </Button>
        <Button
          variant="contained"
          style={{
            background: "#1E88E5",
            color: "#fff",
            borderRadius: "8px",
            padding: "8px 20px",
            fontWeight: "600",
            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
          }}
          onClick={UpdatePackage}
        >
          Update Package
        </Button>
      </div>
    </div>
  </section>
)}

        </>
    );
};

export default UpdateUserByAdmin;
